import { saveAs } from "file-saver"
import { toast } from "react-toastify"
import { url } from "../../../../../constants/url"
import homepageImage from '../../../../../Assests/ReportImages/isecurion1.png'
import { Document, NumberFormat, Packer, PageOrientation, ImageRun, Paragraph, SectionType, BorderStyle, PageNumber, AlignmentType, TableCell, TextRun, TableRow, WidthType, Table, Header, Footer, TableOfContents, TableLayoutType, ShadingType, LevelFormat, convertInchesToTwip, VerticalAlign, HeadingLevel } from "docx"
import { certinDesign, fontPageBlueImage, } from "../../Web/CertIn/Part1/FrontPage"
import { reportAppDate, reportAppName } from "./Part1/FrontPage-Support"
import { documentFirstTable, documentHeading, documentHeading2, documentSecondTable } from "./Part1/Page1-Support"
import { page2firstTable, page2Heading, page2Heading2, page2secondTable } from "./Part1/Page2-Support"
import { TOCHeadings } from "../../Web/CertIn/Part1/Page3-Support"
import { aboutHeading, aboutPage1, aboutPage2, aboutPage3, aboutPage4, bulletfive, bulletfour, bulletOne, bulletsix, bulletThree, bulletTwo } from "./Part1/Page4-Support"
import { disclaimerHeading, disclaimerPage1, disclaimerPage2, disclaimerPage3, disclaimerPage4, disclaimerPage5 } from "./Part1/Page5-Support"
import { ObjectiveandScopeText, objectiveBulletFour, objectiveBulletOne, objectiveBulletThree, objectiveBulletTwo, ObjectivesScopeHeading, scope1, scopeHeading, scopeTable } from "./Part1/Page6-Support"
import { noteUserRoles, recommendationBulletOne, recommendationBulletTwo, sumaryNote1, summaryBulletOne, summaryHeading, SummaryNote, SummaryRecommendation, summeryPage } from "./Part1/Page7-Support"
import { methodologyHeading, methodologyText, setUpAndMethodology } from "./Part2/Page8-Support"
import { applicationBulletFive, applicationBulletFour, applicationBulletOne, applicationBulletSix, applicationBulletThree, applicationBulletTwo, ApplicationThreatModelling, applicationThreatModellingText, informationBulletFive, informationBulletFour, informationBulletOne, informationBulletThree, informationBulletTwo, informationGatheringHeading, informationGatheringText, overview, SourceCodeReview, sourceCodeText1, sourceCodeText2 } from "./Part2/Page9-Support"
import { areaCovered, areaCoveredText, auditPoint1, auditPoint10, auditPoint11, auditPoint12, auditPoint13, auditPoint14, auditPoint15, auditPoint16, auditPoint17, auditPoint18, auditPoint19, auditPoint2, auditPoint20, auditPoint3, auditPoint4, auditPoint5, auditPoint6, auditPoint7, auditPoint8, auditPoint9, framework, frameworkHeading, frameworkText } from "./Part2/Page11-Support"
import { observationSummary, observationText1, scaleShown, severityTable } from "./Part2/Page12-Support"
import { graphText, graphText1, severityLevelTable, tableText } from "./Part2/Page13-Support"
import { findingsText1, overviewHeading } from "./Part2/Page14-Support"
import { Recommendations, stageText1, stageText2, stageText3 } from "./Part3/Page15-Support"
import { Conclusion, conclusionText1, conclusionText10, conclusionText11, conclusionText2, conclusionText3, conclusionText4, conclusionText5, conclusionText6, conclusionText7, conclusionText8, conclusionText9 } from "./Part3/EndPage-Support"

export async function SourceCodeCertInAuditReportSkeleton(props) {
    const {
        date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount, brokenAccess,
        cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures,
        securityFailures, ssrf, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl, appDiscription
    } = props

    const reportName = `Source Code Security Audit Report of ${applicationName}`

    // front page details
    const frontPage1 = certinDesign
    const frontPage2 = fontPageBlueImage
    const frontPage3 = reportAppName(applicationName)
    const frontPage4 = reportAppDate(date)
    // page 1 details
    const page11 = documentHeading
    const page12 = documentFirstTable(applicationName)
    const page13 = documentHeading2
    const page14 = documentSecondTable(customerName, date)

    // page 2 details
    const page21 = page2Heading
    const page22 = page2firstTable(date)
    const page23 = page2Heading2
    const page24 = page2secondTable
    // page 3 details
    const page31 = TOCHeadings
    // page 4 details
    const page41 = aboutHeading
    const page42 = aboutPage1
    const page43 = aboutPage2
    const page44 = aboutPage3
    const page45 = aboutPage4
    const page46 = bulletOne
    const page47 = bulletTwo
    const page48 = bulletThree
    const page49 = bulletfour
    const page50 = bulletfive
    const page411 = bulletsix

    // page 5 details
    const page51 = disclaimerHeading
    const page52 = disclaimerPage1(customerName)
    const page53 = disclaimerPage2
    const page54 = disclaimerPage3(customerName)
    const page55 = disclaimerPage4
    const page56 = disclaimerPage5

    // page 6 details
    const page61 = ObjectivesScopeHeading
    const page62 = ObjectiveandScopeText(applicationName)
    const page63 = objectiveBulletOne
    const page64 = objectiveBulletTwo
    const page65 = objectiveBulletThree
    const page66 = objectiveBulletFour
    const page67 = scopeHeading
    const page68 = scope1(customerName)
    const page69 = scopeTable(applicationName)

    // page 7 details
    const page71 = summaryHeading
    const page72 = summeryPage(customerName, applicationName)
    const page73 = summaryBulletOne(testStartDate, testEndDate)
    const page74 = SummaryNote
    const page75 = sumaryNote1(environmentType, testingType)
    const page76 = noteUserRoles(testingType !== "Black box testing methodology (Unauthenticated Testing)" ? userRoles : '')
    const page77 = SummaryRecommendation
    const page78 = recommendationBulletOne
    const page79 = recommendationBulletTwo

    // page 8 details 
    const page81 = methodologyHeading
    const page82 = methodologyText
    const page83 = setUpAndMethodology

    // page 9 details
    const page91 = informationGatheringHeading
    const page92 = informationGatheringText
    const page93 = informationBulletOne
    const page94 = informationBulletTwo
    const page95 = informationBulletThree
    const page96 = informationBulletFour
    const page97 = informationBulletFive
    const page98 = ApplicationThreatModelling
    const page99 = applicationThreatModellingText
    const page100 = overview
    const pagee911 = applicationBulletOne
    const page912 = applicationBulletTwo
    const pagee913 = applicationBulletThree
    const page914 = applicationBulletFour
    const page915 = applicationBulletFive
    const page916 = applicationBulletSix
    // page 10 details
    const page917 = SourceCodeReview
    const page918 = sourceCodeText1
    const page919 = sourceCodeText2

    // page 11 details
    const page111 = frameworkHeading
    const page112 = framework
    const page113 = frameworkText(applicationName, customerName)
    const page114 = areaCovered
    const page115 = areaCoveredText
    const page116 = auditPoint1
    const page117 = auditPoint2
    const page118 = auditPoint3
    const page119 = auditPoint4
    const page120 = auditPoint5
    const page1111 = auditPoint6
    const page1112 = auditPoint7
    const page1113 = auditPoint8
    const page1114 = auditPoint9
    const page1115 = auditPoint10
    const page1116 = auditPoint11
    const page1117 = auditPoint12
    const page1118 = auditPoint13
    const page1119 = auditPoint14
    const page1120 = auditPoint15
    const page1121 = auditPoint16
    const page1122 = auditPoint17
    const page1123 = auditPoint18
    const page1124 = auditPoint19
    const page1125 = auditPoint20

    // page 12 details 
    const page121 = observationSummary
    const page122 = observationText1(applicationName, vulCount)
    const page123 = scaleShown
    const page124 = severityTable

    // page 13 details
    const page131 = graphText
    const page132 = severityLevelTable(high, medium, low)
    const page133 = tableText
    const page134 = graphText1

    // page 14 details
    const page141 = overviewHeading
    const page142 = findingsText1

    // page 15 details 
    const page151 = Recommendations
    const page152 = stageText1
    const page153 = stageText2
    const page154 = stageText3

    // Ending page details 
    const page161 = Conclusion
    const page162 = conclusionText1(applicationName)
    const page163 = conclusionText2
    const page164 = conclusionText3
    const page165 = conclusionText4
    const page166 = conclusionText5
    const page167 = conclusionText6
    const page168 = conclusionText7
    const page169 = conclusionText8
    const page170 = conclusionText9
    const page1611 = conclusionText10
    const page1612 = conclusionText11(date)

    //   isecurion logo 
    const design = {
        page: {
            margin: { header: 350, footer: 700 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }
    const MAX_WIDTH = 670;
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = Math.min(img.width, MAX_WIDTH);
                const height = width / aspectRatio;
                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            return new ImageRun({
                data: imageData,
                transformation: { width: 624, height: 300 },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // client logo
    let clientImageRun;
    if (image) {
        try {
            const clientImageData = await getBase64(image)
            clientImageRun = new ImageRun({
                data: clientImageData,
                transformation: { width: 100, height: 25 }
            })
            console.log("Selected", clientImageRun);
        }
        catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            clientImageRun = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 100, height: 25 }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }


    const imageData = await fetch(homepageImage).then(response => response.blob());
    const footerIsecurion = new ImageRun({
        type: 'png',
        data: await imageData.arrayBuffer(),
        transformation: {
            width: 225,
            height: 60
        },
    });
    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 6, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            indent: { left: 30, right: 30 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    indent: { left: 600 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 27, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Name of Vulnerability",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 13, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 54, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Recommendations",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                })
            ],
        }),
    ];
    const sortVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);

    sortVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(riskScore) {
            let severity = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
            } else {
                severity = "Info";
            }
            return { severity };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity } = getSeverityAndColor(riskScore);

        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                indent: { left: 60 },
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),

                    new TableCell({
                        width: { size: 53, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    indent: { left: 500, right: 50 },
                                    spacing: { before: 50, after: 50 },
                                    bullet: { level: 0 },
                                    alignment: AlignmentType.LEFT,
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                    ]
                                })
                            )

                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    })

                ],
            })
        );
    });

    // Vulnerability Table
    const sortedVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            combinedContent.push(
                new Paragraph({
                    children: [
                        new TextRun({
                            text: `${pocText}`,
                            size: 24,
                        }),
                    ],
                })
            );

            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }


        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Informational";
                color = "00b050";
            }

            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);

        return [
            new Paragraph({
                pageBreakBefore: true,
                heading: HeadingLevel.HEADING_2,
                spacing: { before: 150, after: 100 },

                numbering: { reference: "my-crazy-numbering", level: 0 },
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 22,
                        color: "000000",
                        font: "Calibri",
                        bold: true,
                        italics: false
                    })
                ],
            }),
            new Table({
                width: { size: 106, type: WidthType.PERCENTAGE },
                alignment: AlignmentType.LEFT,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },

                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Vulnerability",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,
                                        // indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Description",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.JUSTIFIED,
                                    indent: { left: 100, right: 80 },
                                    children: [new TextRun({
                                        text: vulnerability.description,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "OWASP Category ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true.valueOf,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    indent: { left: 100, right: 80 },
                                    alignment: AlignmentType.LEFT,
                                    // indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.OWASP,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected URL Address ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.affectedParameter.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 50, after: 50 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,

                                        children: [
                                            new TextRun({
                                                text: url,
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            })
                                        ]
                                    })
                                ),

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk/Impact",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    indent: { left: 100, right: 80 },
                                    alignment: AlignmentType.LEFT,
                                    // indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.risk,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Ease of Exploitation",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.exploitation,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS String",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.cvssString,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            // First cell: CVSS Score/ Risk Rating header
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: "CVSS Score/ Risk Rating",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            // Second cell: Risk score and severity
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: `${riskScore} / ${severity}`,
                                                font: "Calibri",
                                                size: 22,
                                                color: color,
                                                italics: false,
                                                bold: true
                                            })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            })
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation/ Solution",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                spacing: { before: 50, after: 50 },

                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is recommended to:",
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            indent: { left: 700, right: 80 },
                                            spacing: { before: 100, after: 100 },
                                            bullet: { level: 0 },
                                            children: [
                                                new TextRun({
                                                    text: bulletText.trim(),
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "000000",
                                                    italics: false
                                                })
                                            ]
                                        })
                                    )

                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100, right: 80 },
                                        children: [new TextRun({
                                            text: "",
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({ pageBreakBefore: true }),
            new Paragraph({
                spacing: { after: 200 },
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "000000",
                        font: "Calibri",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);


    let FrontPageClientLogo;

    if (image) {
        try {
            const clientImageData = await getBase64(image)
            FrontPageClientLogo = new ImageRun({
                transformation: { width: 220, height: 140 },
                data: clientImageData,
                floating: {
                    zIndex: 10,
                    horizontalPosition: { offset: 2090000 },
                    verticalPosition: { offset: 2500000 },
                }
            })
            console.log("Selected", FrontPageClientLogo);
        } catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            FrontPageClientLogo = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 220, height: 140 },
                floating: {
                    zIndex: 10,
                    horizontalPosition: { offset: 2090000 },
                    verticalPosition: { offset: 2500000 },
                }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }

    const doc = new Document({
        creator: "ISECURION",
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [

                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "9.%1",
                            alignment: AlignmentType.LEFT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "#0f0f3f", bold: true, size: 24, font: "Calibri" },
                                run: {
                                    size: 22,
                                    bold: true,
                                    color: "000000",
                                    font: "Cambria"
                                },
                            },
                        },
                        // {
                        //     level: 2,
                        //     format: LevelFormat.DECIMAL,
                        //     text: "11.%3",
                        //     alignment: AlignmentType.RIGHT,
                        //     style: {
                        //         paragraph: {
                        //             indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                        //         },
                        //         run: {
                        //             size: 24,
                        //             bold: true,
                        //             color: "0f0f3f",
                        //             font: "Calibri"
                        //         },
                        //     },
                        // },

                    ]
                }
            ]
        },
        features: { updateFields: true },
        styles: {
            default: {
                document: {
                    run: {
                        font: "Calibri",
                        bold: false,
                        size: 22,
                        color: "000000",
                    },
                },
                heading1: {
                    run: {
                        size: 26,
                        color: "C00000",
                        font: "Cambria",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading2: {
                    run: {
                        size: 26,
                        color: "C00000",
                        font: "Cambria",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading3: {
                    run: {
                        font: "Cambria",
                        size: 24,
                        bold: true,
                        color: "0f0f3f",
                        italics: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },

            },
        },
        sections: [
            //---------------------- page frontPage  Start----------------------
            {
                properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
                children: [frontPage1, frontPage2, frontPage3, frontPage4, new Paragraph({
                    children: [FrontPageClientLogo]
                })]
            },
            //---------------------- page frontPage End----------------------
            //---------------------- page 1  Start----------------------
            {
                properties: {
                    page: {
                        margin: { header: 350, footer: 700 },
                        size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                        type: SectionType.CONTINUOUS,
                    },
                },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                margin: { top: 400 },
                                width: { size: 110, type: WidthType.PERCENTAGE },
                                alignment: AlignmentType.LEFT,
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.LEFT, children: [footerIsecurion] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),

                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                margin: { top: 600 },
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [

                                            new TableCell({
                                                width: { size: 65, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Confidential 2026",
                                                                font: "Calibri",
                                                                size: 22,
                                                                italics: false,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 32, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Page",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 22,
                                                                bold: true,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 3, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 22,
                                                                bold: true,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                },
                children: [page11, page12, page13, page14]
            },
            //---------------------- page 1 End----------------------
            //---------------------- page 2  Start----------------------
            {
                properties: { ...design },
                children: [page21, page22, page23, page24],
                pageBreakBefore: true
            },
            //---------------------- page 2 End----------------------
            //---------------------- page 3  Start----------------------
            {
                properties: { ...design },
                children: [page31,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        // indent: { size: 500, type: WidthType.DXA },
                        rows: [
                            new TableRow({

                                children: [
                                    new TableCell({
                                        width: { size: 100, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
                pageBreakBefore: true
            },
            //---------------------- page 3 End----------------------
            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [page41, page42, page43, page44, page45, page46, page47, page48, page49, page50, page411],
                pageBreakBefore: true
            },
            //---------------------- page 4 End----------------------
            //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [page51, page52, page53, page54, page55, page56],
                pageBreakBefore: true
            },
            //---------------------- page 5 End----------------------
            //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [page61, page62, page63, page64, page65, page66, page67, page68, page69],
                pageBreakBefore: true
            },
            //---------------------- page 6 End----------------------
            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [page71, page72, page73, page74, page75, page76, page77, page78, page79],
                pageBreakBefore: true
            },
            //---------------------- page 7 End----------------------
            //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [page81, page82, page83],
                pageBreakBefore: true
            },
            //---------------------- page 8 End----------------------
            //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [page91, page92, page93, page94, page95, page96, page97, page98, page99, page100, pagee911, page912, pagee913, page914, page915, page916,],
                pageBreakBefore: true
            },
            //---------------------- page 9 End----------------------
            //---------------------- page 10 Start----------------------
            {
                properties: { ...design },
                children: [page917, page918, page919],
                pageBreakBefore: true
            },
            //---------------------- page 10 End----------------------
            //---------------------- page 11 Start----------------------
            {
                properties: { ...design },
                children: [page111, page112, page113, page114, page115, page116, page117, page118, page119, page120, page1111, page1112, page1113, page1114, page1115, page1116, page1117, page1118, page1119, page1120, page1121, page1122, page1123, page1124, page1125],
                pageBreakBefore: true
            },
            //---------------------- page 11 End----------------------
            //---------------------- page 12 Start----------------------
            {
                properties: { ...design },
                children: [page121, page122, page123, page124],
                pageBreakBefore: true
            },
            //---------------------- page 12 End----------------------
            {
                properties: { ...design },
                children: [page131, page132, page133, page134],
                pageBreakBefore: true
            },
            {
                properties: { ...design },
                children: [page141, page142,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        spacing: { before: 1200 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        },
                        rows: rows
                    })
                ]
            },
            {
                properties: { ...design },
                children: [page151, page152, page153, page154,],
                pageBreakBefore: true
            },
            {
                properties: { ...design },
                children: [...docSectionsResolved.flat()],
                pageBreakBefore: true
            },
            {
                properties: { ...design },
                children: [page161, page162, page163, page164, page165, page166, page167, page168, page169, page170, page1611, page1612],
                pageBreakBefore: true
            },

        ]
    })
    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            });
            return
        }

    } catch (error) {
        console.log(error)
    }
}
